module.exports = __webpack_public_path__ + "img/pin.ce937607.svg";